export const FeedTypes = {
  // Note: PrimaryFeed's MT key is also OfferFeed, whose distinguish way is whether ShowDestinations is true
  PrimaryFeed: _TL_('Primary Feed'),
  OfferFeed: _TL_('Online Product'),
  Product: _TL_('Product'),
  ProductInventory: _TL_('Product Inventory'),
  LocalProduct: _TL_('Local Product'),
  LocalProductInventory: _TL_('Local Product Inventory'),
  LocalProductInventoryUpdate: _TL_('Local Product Inventory Update'),
  ProductUpdateFeed: _TL_('Online Product Inventory Update'),
  SupplementalFeed: _TL_('Supplemental Feed'),
  ProductCollections: _TL_('Product Collections'),
};

export const Destinations = {
  Shopping_ads: _TL_('Online product ads'),
  Local_inventory_ads: _TL_('Local inventory ads'),
};
